import { render, staticRenderFns } from "./ClinicalQualityManagementServices.vue?vue&type=template&id=2e740faa&"
import script from "./ClinicalQualityManagementServices.vue?vue&type=script&lang=js&"
export * from "./ClinicalQualityManagementServices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports